import {
  API_CAMPAIGN_REQUEST_ENDPOINT_V1,
  API_WIDGET_REQUEST_ENDPOINT_V1,
  API_FLAG_SEGMENT_ENDPOINT,
} from 'utils/constants';
import { appendQuery } from 'utils/http';
import { request } from '../http';
import {
  FlagSegmentConfig,
  GetCampaignPreviewResponse,
  GetWidgetUnitsConfig,
  GetWidgetUnitsResponse,
} from './types';

export async function getWidgetUnits(
  widgetId: string,
  { url, q, sessionId, variantIdOverride }: GetWidgetUnitsConfig = {},
): Promise<GetWidgetUnitsResponse> {
  const apiUrl = appendQuery(API_WIDGET_REQUEST_ENDPOINT_V1, {
    q,
    sessionId,
    url,
    variantIdOverride,
    widgetId,
  });
  const { data } = await request.get(apiUrl);
  return data;
}

export async function getCampaignPreview(
  campaignFeedId: number,
): Promise<GetCampaignPreviewResponse> {
  const apiUrl = appendQuery(API_CAMPAIGN_REQUEST_ENDPOINT_V1, {
    campaignFeedId,
  });
  const { data } = await request.get(apiUrl);
  return data;
}

export async function flagSegment({
  widgetId,
  flag,
  resultId,
  url,
  prId,
  sessionId,
}: FlagSegmentConfig): Promise<void> {
  await request.post(API_FLAG_SEGMENT_ENDPOINT, {
    widgetId,
    flag,
    resultId,
    url,
    prId,
    sessionId,
  });
  return undefined;
}
